import { AuthenticationDetails, CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js'
import { awsInfo } from './aws-info'

class CognitoUserAccessor {

    init(username, password) {
        const authenticationData = {
            Username: username,
            Password: password,
        }
        self.authenticationDetails = new AuthenticationDetails(authenticationData)
        const poolData = {
            UserPoolId: awsInfo.userPoolId,
            ClientId: awsInfo.appClientId,
        }
        self.userPool = new CognitoUserPool(poolData)
        const userData = {
            Username: username,
            Pool: self.userPool
        }
        self.cognitoUser = new CognitoUser(userData)
    }

    async signin() {
        return new Promise((resolve, reject) => {
            self.cognitoUser.authenticateUser(self.authenticationDetails, {
                onSuccess: function (result) {
                    resolve(result)
                },
                onFailure: function (err) {
                    reject(err)
                },
                newPasswordRequired: function (userAttributes, requiredAttributes) {
                    requiredAttributes
                    userAttributes.newPasswordRequired = true
                    resolve(userAttributes)
                }
            })
        })
    }

    async newPasswordChallenge(newPassword) {
        return new Promise((resolve, reject) => {
            self.cognitoUser.completeNewPasswordChallenge(newPassword, null, {
                onSuccess: function (result) {
                    resolve(result)
                },
                onFailure: function (err) {
                    reject(err)
                },
            })
        })
    }

    static getUserPool() {
        const poolData = {
            UserPoolId: awsInfo.userPoolId,
            ClientId: awsInfo.appClientId,
        }
        return new CognitoUserPool(poolData)
    }

    static signout() {
        return this.getUserPool().getCurrentUser().signOut()
    }

    static isAuthenticated() {
        const cognitoUser = this.getUserPool().getCurrentUser()
        return new Promise((resolve, reject) => {
            if (cognitoUser === null) { reject(cognitoUser) }
            cognitoUser.getSession((err, session) => {
                if (err) {
                    reject(err)
                } else {
                    if (!session.isValid()) {
                        reject(session)
                    } else {
                        resolve(session)
                    }
                }
            })
        })
    }

    static async changePassword(oldPassword, newPassword) {
        const cognitoUser = this.getUserPool().getCurrentUser()
        return new Promise((resolve, reject) => {
            cognitoUser.getSession((err, session) => {
                if (err) {
                    reject(err)
                }
                if (!session.isValid()) {
                    reject(session)
                }
                cognitoUser.changePassword(oldPassword, newPassword, (err, result) => {
                    if (err) {
                        reject(err)
                    }
                    resolve(result)
                })
            })
        })
    }

    static forgotPassword(email) {
        const userData = { Username: email, Pool: this.getUserPool() }
        const cognitoUser = new CognitoUser(userData)
        return new Promise((resolve, reject) => {
            cognitoUser.forgotPassword({
                onSuccess: (result) => {
                    resolve(result)
                },
                onFailure: (err) => {
                    reject(err)
                }
            })
        })
    }

    static resetPassword(email, newPassword, code) {
        const userData = { Username: email, Pool: this.getUserPool() }
        const cognitoUser = new CognitoUser(userData)
        return new Promise((resolve, reject) => {
            cognitoUser.confirmPassword(code, newPassword, {
                onSuccess: (result) => {
                    resolve(result)
                },
                onFailure: (err) => {
                    reject(err)
                }
            })
        })
    }

    static async getCurrentUser() {
        return new Promise((resolve, reject) => {
            const cognitoUser = this.getUserPool().getCurrentUser()
            if (!cognitoUser) {
                reject('need login')
            } else {
                cognitoUser.getSession((err, session) => {
                    if (err) {
                        reject(err)
                    } else if (!session.isValid()) {
                        reject('need login')
                    } else {
                        resolve(session)
                    }
                })
            }
        })
    }
}

export { CognitoUserAccessor }
